<template>
  <div id="hello">
      首页
  </div>
</template>

<script>
export default {

  data () {
    return {

    }
  },
  computed:{

  },
  created(){

  },
  mounted(){
   
  },
  methods:{

  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" >
#hello{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue